import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  const layout = localStorage.getItem("layout") || "default";

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        fontFamily: "Inter, sans-serif",
      }}
    >
      <div style={{ textAlign: "center", padding: 40 }}>
        <div
          style={{
            fontSize: 80,
            fontWeight: 800,
            color: "#0062FE",
            lineHeight: 1,
          }}
        >
          404
        </div>
        <h2
          style={{
            fontSize: 22,
            fontWeight: 700,
            color: "#071b33",
            margin: "12px 0 8px",
          }}
        >
          Page Not Found
        </h2>
        <p
          style={{
            fontSize: 14,
            color: "#6b7280",
            margin: "0 0 24px",
            maxWidth: 400,
          }}
        >
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link
          to={`${process.env.PUBLIC_URL}/dashboard/${layout}`}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            padding: "10px 24px",
            background: "#0062FE",
            color: "#fff",
            borderRadius: 8,
            textDecoration: "none",
            fontSize: 14,
            fontWeight: 600,
          }}
        >
          ← Back to Dashboard
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
